module.exports = __webpack_public_path__ + "media/icons/rok-produkcji-ba41516f.png";